<template>
	<div>
		<v-expansion-panels accordion  flat>
			<v-expansion-panel
			v-for="(faq,i) in faq_list"
			:key="i"
			expand-icon=" asa"
			>
			<v-expansion-panel-header class="secondary-text">{{faq.question}}</v-expansion-panel-header>
			<v-expansion-panel-content class="secondary-text">
				Answer: {{faq.answer}}
			</v-expansion-panel-content>
		</v-expansion-panel>
	</v-expansion-panels>
</div>
</template>

<script type="text/javascript">
export default {
	data () {
		return {
			wholesaler_details:{
				firm_name:"",
				email:"",
				full_address:"",
				landline_number:"",
				mobile:"",
				pincode:"",
				shop_number:"",
				wholesaler_id:"",
			},
			medx_contact_email:"",
			medx_contact_number_1:"",
			medx_contact_number_2:"",
			medx_contact_address:"",
			faq_list:[],
		}
	},

	created(){
		this.getFAQ()
		this.$store.dispatch('drawer/setActiveTab',-1) 
	},
	methods:{
		getFAQ(){
			this.$store.dispatch('setPageLoader', true)
			const self=this
			let params={};
			const successHandler = (response) => {

				if (response.data.success){
					self.medx_contact_email=response.data.medx_contact_email;
					self.medx_contact_number_1=response.data.medx_contact_number_1;
					self.medx_contact_number_2=response.data.medx_contact_number_2;
					self.medx_contact_address=response.data.medx_contact_address;
					self.faq_list=response.data.faq_list;

				}
			};
			const finallyHandler = () => {
				this.$store.dispatch('setPageLoader', false)

			};
			self.request_GET( self,self.$urls.CONTACT_DETAILS,params,successHandler,null,null,finallyHandler)
		}
	}
}


</script>